import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NoDirectAccessGuard } from './shared/guards/no-direct-access-guard';
import { LandingModule } from './modules/landing/landing.module';

const routes: Routes = [{
  path: '',
  children: [
    {
      path: 'home',
      loadChildren: () =>
        import('./modules/landing/landing.module').then(m => m.LandingModule)
    },
    {
      path: 'descargar-guia-medica',
      loadChildren: () =>
        import('./modules/download-medical-guide/download-medical-guide.module').then(m => m.DownloadMedicalGuideModule)
    },
    {
      path: 'doctors-centers',
      loadChildren: () =>
        import('./modules/doctors-centers/doctors-centers.module').then(m => m.DoctorsCentersModule)
    },
    {
      path: '',
      canActivateChild: [NoDirectAccessGuard],
      children: [
        {
          path: 'services',
          loadChildren: () =>
            import('./modules/home/home.module').then(m => m.HomeModule)
        },
        {
          path: 'search-detail',
          loadChildren: () =>
            import('./modules/search-detail/search-detail.module').then(m => m.SearchDetailModule)
        },
        {
          path: 'search-location',
          loadChildren: () =>
            import('./modules/search-location/search-location.module').then(m => m.SearchLocationModule)
        },
        {
          path: 'search-results',
          loadChildren: () =>
            import('./modules/search-results/search-results.module').then(m => m.SearchResultsModule)
        },
        {
          path: 'search-results/:page',
          loadChildren: () =>
            import('./modules/search-results/search-results.module').then(m => m.SearchResultsModule)
        },
        {
          path: 'diagnostic-test',
          loadChildren: () =>
            import('./modules/diagnostic-test/diagnostic-test.module').then(m => m.DiagnosticTestModule)
        },
        {
          path: 'emergency-centers',
          loadChildren: () =>
            import('./modules/emergency-centers/emergency-centers.module').then(m => m.EmergencyCentersModule)
        },
        {
          path: 'additional-services',
          loadChildren: () =>
            import('./modules/additional-services/additional-services.module').then(m => m.AdditionalServicesModule)
        }
      ]
    }
  ]
}];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
